import { Card } from '@/components/ui/card';

import caso2 from '@/assets/caso-2.webp';
import caso4 from '@/assets/caso-4.webp';
import caso6 from '@/assets/caso-6.webp';
import lente01 from '@/assets/lente-01.webp';
import lente02 from '@/assets/lente-02.webp';
import lente03 from '@/assets/lente-03.webp';
import lente04 from '@/assets/lente-04.webp';
import lente05 from '@/assets/lente-05.webp';
import lente06 from '@/assets/lente-06.webp';
import lente07 from '@/assets/lente-07.webp';
import lente08 from '@/assets/lente-08.webp';
import lente09 from '@/assets/lente-09.webp';

type Orientation = 'horizontal' | 'vertical';

const caseImages: { src: string; alt: string; title: string; orientation: Orientation }[] = [
  { src: lente01, alt: 'Lentes dentais — sorriso natural', title: 'Lentes Dentais', orientation: 'horizontal' },
  { src: lente02, alt: 'Lentes de porcelana — resultado estético', title: 'Lentes de Porcelana', orientation: 'horizontal' },
  { src: lente03, alt: 'Sorriso renovado com lentes', title: 'Sorriso Renovado', orientation: 'horizontal' },
  { src: lente04, alt: 'Lentes dentais aplicadas', title: 'Lentes Aplicadas', orientation: 'horizontal' },
  { src: lente05, alt: 'Detalhe de lentes em resina estratificada', title: 'Resina Estratificada', orientation: 'horizontal' },
  { src: lente06, alt: 'Lentes dentais de alta estética', title: 'Alta Estética', orientation: 'horizontal' },
  { src: lente07, alt: 'Detalhe macro de lentes dentais', title: 'Detalhe Macro', orientation: 'horizontal' },
  { src: lente08, alt: 'Lentes 3D by Luan Maciel', title: 'Lentes 3D', orientation: 'horizontal' },
  { src: lente09, alt: 'Lentes dentais — vista frontal', title: 'Vista Frontal', orientation: 'horizontal' },
  { src: caso2, alt: 'Resultado de lentes de contato dental', title: 'Lentes de Contato', orientation: 'vertical' },
  { src: caso4, alt: 'Tratamento estético dental', title: 'Estética Dental', orientation: 'vertical' },
  { src: caso6, alt: 'Transformação completa do sorriso', title: 'Transformação', orientation: 'vertical' },
];

const CasesGallery = () => {
  return (
    <section className="py-16 md:py-24 bg-[#F6F5F5]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-sm font-medium border border-accent text-accent rounded-full mb-4">
            RESULTADOS REAIS
          </span>
          <h2 className="font-kiona text-3xl md:text-4xl lg:text-5xl text-primary mb-4 uppercase tracking-wide">
            Veja Alguns Casos
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Milhares de sorrisos renovados!
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[110px] sm:auto-rows-[140px] md:auto-rows-[160px] lg:auto-rows-[130px] gap-4 md:gap-6 max-w-6xl mx-auto">
          {caseImages.map((image, index) => (
            <Card
              key={`case-${index}`}
              className={`overflow-hidden bg-card border-0 shadow-lg group transition-all duration-500 hover:shadow-xl rounded-2xl ${
                image.orientation === 'horizontal'
                  ? 'sm:col-span-2 lg:col-span-2 row-span-2'
                  : 'sm:col-span-1 lg:col-span-2 row-span-3'
              }`}
            >
              <div className="relative w-full h-full overflow-hidden bg-secondary">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <h3 className="text-white font-medium text-lg">{image.title}</h3>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CasesGallery;
